export const link = (href: string, title: string | undefined, text: string) => {
  return `
    <a ${
      title !== undefined ? `title="${title}"` : ''
    } href="${href}" target="_blank" rel="nofollow">
      ${text}
    </a>`
}
